import { render, staticRenderFns } from "./BasicInput.vue?vue&type=template&id=66247582&scoped=true"
import script from "./BasicInput.vue?vue&type=script&lang=js"
export * from "./BasicInput.vue?vue&type=script&lang=js"
import style0 from "./BasicInput.vue?vue&type=style&index=0&id=66247582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66247582",
  null
  
)

export default component.exports